// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard/default';
export const DRAWER_WIDTH = 280; // increased from 260 to make sidebar slightly wider
export const MINI_DRAWER_WIDTH = 64; // small increase for mini drawer


const config = {
  fontFamily: `'Public Sans', sans-serif`
};

export default config;
